// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9e0b684a","455":"5429fc10","977":"1567c338"}[chunkId] + ".chunk.js";
};